/* eslint-disable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { toastr } from "react-redux-toastr";
import _ from "lodash/fp";
import "../../styles/challan_management.css";
import commonLabels from "../../../common/labels/common_en.json";
import "bootstrap/dist/css/bootstrap.min.css";
import AccordionItemData from "./AccordionItemData";
import applicationStagesLabels from '../labels/applicationstages_en.json'
import { hideLoader, showLoader } from "../../../common/actions/commonActions";
import {
  getAllStagesList,
  getAllStageConfigByAdvId,
  getAdvertisementDetailsByAdvertisementId,
  updateFeeConfigData,
  resetAdvertisementDetails,
  getSubjectsListByPostCriteriaId,
  getReUploadApplicationDocList,
  getReDownloadApplicationDocList,
  getExamPaperDetails,
  getObjectionAnswerKeyData,
  getAllObjectionFilesData,
} from "../actions/applicationStagesAction";
import {
  getActiveExamList,
  getExamTemplateListForImportAdmitCardCsvAPI,
  getselectExamListing
} from "../../../timetablemanagement/actions/timetableManagementAction";
import AddTimeTable from "../components/AddTimeTable";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { GET_TIME_TABLE_LISTING } from "../../../common/constants/ActionTypes";

const AdvertisementDetails = ({ advtNo, isPast }) => {
  let rowPerPage = 10;
  const { register, errors } = useForm({
    mode: "onChange",
  });

  let intialVal = {
    objection_fee: 0,
    objection_service_charges: 0,
    retotaling_fee: 0,
    retotaling_service_charges: 0,
  };

  const [configFeeArray, setConfigFeeArray] = useState(intialVal);
  const [showAddTimeTableState, setShowAddTimeTableState] = useState(false);

  const dispatch = useDispatch();
//   const { challanDetails } = useSelector(
//     (state) => state.challanManagementReducer,
//     shallowEqual
//   );
  const { allStagesList, allStageConfigList, advertisementDetails } =
    useSelector((state) => state.applicationManagementReducer, shallowEqual);
  
  const { getTimeTableExams } = useSelector((state) => state.timeTableManagementReducer, shallowEqual);
  let examName = advertisementDetails && advertisementDetails.advertisement && advertisementDetails.advertisement.exam && advertisementDetails.advertisement.exam.name;

  useEffect(() => {
    if (advtNo) {
      let pcid = "";
      dispatch(getSubjectsListByPostCriteriaId(pcid, advtNo));
      dispatch(getReUploadApplicationDocList(0, rowPerPage, advtNo));
      dispatch(getReDownloadApplicationDocList(0, rowPerPage, advtNo));
      dispatch(getActiveExamList(advtNo));
      dispatch(getExamPaperDetails("exam_paper_set"));
      dispatch(getExamPaperDetails("exam_paper_questions_limit"));
      dispatch(getObjectionAnswerKeyData(advtNo));
      dispatch(getAllObjectionFilesData(0, rowPerPage, advtNo));
      dispatch(getAllStageConfigByAdvId(advtNo));
      dispatch(getAdvertisementDetailsByAdvertisementId(advtNo));
      dispatch(getAllStagesList());
    }
    dispatch(resetAdvertisementDetails());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [advtNo]);

  useEffect(() => {
    let examId =
      advertisementDetails &&
      advertisementDetails.advertisement &&
      advertisementDetails.advertisement.exam &&
      advertisementDetails.advertisement.exam.id;
    examId && dispatch(getExamTemplateListForImportAdmitCardCsvAPI(examId));
  }, [advertisementDetails]);

  useEffect(() => {
    let newConfigFeeArray = configFeeArray;
    let data = advertisementDetails && advertisementDetails.advertisementConfig && advertisementDetails.advertisementConfig;
    if (data && data.objectionFee) {
      newConfigFeeArray.objection_fee = data.objectionFee;
    }
    if (data && data.objectionServiceCharges) {
      newConfigFeeArray.objection_service_charges = data.objectionServiceCharges;
    }
    if (data && data.retotalingFee) {
      newConfigFeeArray.retotaling_fee = data.retotalingFee;
    }
    if (data && data.retotalingServiceCharges) {
      newConfigFeeArray.retotaling_service_charges = data.retotalingServiceCharges;
    }
    setConfigFeeArray(newConfigFeeArray);
  }, [configFeeArray, advertisementDetails]);

  const setFieldValue = (name, e) => {
    /* eslint-disable no-useless-escape */
    const value = e.target.value.replace(/[^\d\.]/g, "");
    var piecesArray = value.split(".");
    if (piecesArray.length > 2)
      toastr.error("Please enter valid decimal number");
    let newConfigFeeArray = configFeeArray;
    if (name === "objection_fee") {
      newConfigFeeArray.objection_fee = value;
    } else if (name === "objection_service_charges") {
      newConfigFeeArray.objection_service_charges = value;
    } else if (name === "retotaling_fee") {
      newConfigFeeArray.retotaling_fee = value;
    } else if (name === "retotaling_service_charges") {
      newConfigFeeArray.retotaling_service_charges = value;
    } else {
    }
    setConfigFeeArray(newConfigFeeArray);
  };
  const updateAdvertimentFeeConfigData = () => {
    let requestBody = {
      advertisementConfig: {
        advertisementId: advtNo,
        retotalingFee: configFeeArray.retotaling_fee,
        retotalingServiceCharges: configFeeArray.retotaling_service_charges,
        objectionFee: configFeeArray.objection_fee,
        objectionServiceCharges: configFeeArray.objection_service_charges,
      },
    };

    dispatch(updateFeeConfigData(advtNo, requestBody));
  };

  const onAddTimeTable = () => {
    dispatch({
      type: GET_TIME_TABLE_LISTING,
      payload: [],
    });
    setShowAddTimeTableState(true);
  };

  const handleViewPrintBtnClick = () => {
    let examId =
      advertisementDetails &&
      advertisementDetails.advertisement &&
      advertisementDetails.advertisement.exam &&
      advertisementDetails.advertisement.exam.id;
    examId && dispatch(getselectExamListing(examId, true))
      .then((response) => {
        dispatch(showLoader());
        setTimeout(() =>{
          exportPDF();
          dispatch(hideLoader());
        },3000)
      })
      .catch((error) => { });
  };

  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "landscape";
    const doc = new jsPDF(orientation, unit, size);
    doc.setFontSize(15);
    const title = `${applicationStagesLabels.TIME_TABLE_DETAILS}`;
    var xOffset = doc.internal.pageSize.width / 2;
    doc.text(title, xOffset, 20, { align: 'center' });
    doc.setFontSize(11);
    let advtNo = advertisementDetails && advertisementDetails.advertisement && advertisementDetails.advertisement.advertisementNo;
    let advtYear = advertisementDetails && advertisementDetails.advertisement && advertisementDetails.advertisement.year;
    let advtName = advertisementDetails && advertisementDetails.advertisement && advertisementDetails.advertisement.name;

    const title1 = `${applicationStagesLabels.ADVT_NAME} ${advtNo}/${advtYear}-${advtName}`;
    var xOffset = doc.internal.pageSize.width / 2;
    doc.text(title1, 10, 40, { align: 'left' });

    doc.autoTable({
      startY: 60,
      html: '#simple_table',
      margin: { horizontal: 10 },
      theme: "grid",
      bodyStyles: { valign: "top" },
      headStyles: { fillColor: '#067FD0', halign: 'center' },
      styles: { overflow: 'linebreak', cellWidth: 'auto', cellPadding: 1, fontSize: 10 },
      columnStyles: { 0: { halign: 'center' }, 1: { halign: 'left' }, 2: { halign: 'center' }, 3: { halign: 'center' }, 4: { halign: 'center' }, 5: { halign: 'center' }, 6: { halign: 'center' }, 7: { halign: 'left' }, 8: { halign: 'center' }, 9: { halign: 'center' }, text: { cellWidth: 'auto' } },
      showHead: "firstPage",
      didDrawPage: (data) => {
        doc.setFontSize(20);
        doc.setTextColor(40);
        var str = "Page " + doc.internal.getNumberOfPages();

        doc.setFontSize(10);
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        doc.text(str, data.settings.margin.left, pageHeight - 10);
      }
    });
    doc.save("timetable_exams_report.pdf")
  };

  const formatAMPM = (time24) => {
    var time = time24.split(":");
    var hours = parseInt(time[0]);
    var minutes = parseInt(time[1]);
    var suffix = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    return hours + ":" + minutes + " " + suffix;
  };

  return (
    <div className="row pt-4">
      <main
        role="main"
        className="col-sm-7 col-md-8 col-lg-9 border-right"
        id="main_block"
      >
        {/* <div
          className="box-one customButtonStyle"
        >
          <div
            className="box-contents ps-2 pe-2"
          >
            <div className="row mar_LeftRight_0">
              <div className="col-md-8 advertisement_details_firstrow border border-light">
                <div className="row">
                  <div className="col-md-6 fw-bold">
                    {applicationStagesLabels.Advertisement_No}{" "}
                    {challanDetails.advertisementNo}{" "}
                  </div>
                </div>
                <hr />
                <span className="fw-bold">
                  {challanDetails.advertisementNameEng} |{" "}
                  {challanDetails.advertisementNameDvng}{" "}
                </span>
                <br />
                <span className="fw-bold">
                  {" "}
                  {applicationStagesLabels.EXAMINATION} {challanDetails.examNameEng}{" "}
                </span>
                <br />
                <br />
                <span> {challanDetails.advertisementDescriptionEng} </span>
                <br />
                <span> {challanDetails.advertisementDescriptionDvng} </span>
              </div>
              <div className="col-md-4 advertisement_details_firstrow border border-light">
                <label className="fw-bold">
                  {applicationStagesLabels.Start_Date_Application}{" "}
                </label>
                <span className="float-end">
                  {challanDetails.applnStartDate
                    ? dayjs(challanDetails.applnStartDate).format("DD/MM/YYYY")
                    : ""}
                </span>
                <label className="fw-bold">
                  {applicationStagesLabels.Last_Date_Challan}
                </label>
                <span className="float-end">
                  {challanDetails.challanPaymentEndDate
                    ? dayjs(challanDetails.challanPaymentEndDate).format(
                      "DD/MM/YYYY"
                    )
                    : ""}
                </span>
                <label className="fw-bold">
                  {applicationStagesLabels.Exam_Mode}
                </label>
                <span className="float-end"></span>
                <br />
                <label className="fw-bold">
                  {applicationStagesLabels.Number_of_Subjects}
                </label>
                <span className="float-end">
                  {challanDetails.noOfSubjects}
                </span>
              </div>
            </div>
          </div>
        </div> */}
        <div
          className="allApplicationStages ms-4 me-0">
          <div className="panel-group" id="accordion">
            {allStagesList &&
              allStagesList.stageDtoList &&
              allStagesList.stageDtoList.length > 0 &&
              allStagesList.stageDtoList.map((elem, index) => {
                return (
                  <AccordionItemData
                    key={index}
                    ikey={index}
                    title={elem.name}
                    stageConfigData={allStageConfigList && JSON.stringify(allStageConfigList)}
                    advertisementDetailsData={JSON.stringify(
                      advertisementDetails
                    )}
                    stageData={JSON.stringify(elem)}
                    advertisementId={advtNo}
                    itemKey={elem.id}
                    stageCode={elem.code}
                    isPast={isPast}
                  />
                );
              })}
          </div>
        </div>
      </main>
      <div className="col-sm-5 col-md-4 col-lg-3 d-md-block">
        <button
          type="submit"
          className=" btn btn-primary custom_button  btn-sm mb-3  "
          onClick={() => {
            onAddTimeTable();
          }}
        >
          {applicationStagesLabels.AddTimeTable}
        </button>
        {(advertisementDetails && advertisementDetails.isTimeTableSet) &&
          <button
            type="submit"
            className=" btn btn-primary custom_button  btn-sm mb-3 ms-2  "
            onClick={() => {
              handleViewPrintBtnClick();
            }}
          >
            {applicationStagesLabels.VIEW_TIME_TABLE}
          </button>
        }
        <div className="d-none">
          {(getTimeTableExams && getTimeTableExams.timeTableExamsDtoList && getTimeTableExams.timeTableExamsDtoList.length > 0) &&
            <table className="table" id="simple_table">
              <thead>
                <tr>
                  {applicationStagesLabels && applicationStagesLabels.TimeTableDetailsHeader && applicationStagesLabels.TimeTableDetailsHeader.map((itm, ind) => {
                    return (<>
                      {itm == "" ? <th key={ind} className='text-center w90 theadBgColor'>{itm}</th> : (ind === 1 || ind === 7 || ind === 10) ? <th key={ind} className='text-left' >{itm}</th> : <th key={ind} className='text-center' >{itm}</th>}
                    </>
                    );
                  }
                  )}

                </tr>
              </thead>
              <tbody>
                {getTimeTableExams && getTimeTableExams.timeTableExamsDtoList && getTimeTableExams.timeTableExamsDtoList.length > 0 &&
                  getTimeTableExams.timeTableExamsDtoList.map((item, indx) => {
                    return (
                      <tr key={indx}>
                        <td className="w-5 word-break text-center">
                          {indx + 1}
                        </td>
                        <td className="word-break">
                          {examName}
                        </td>
                        <td className="word-break">
                          {applicationStagesLabels && applicationStagesLabels.days && applicationStagesLabels.days[new Date(item.examDate).getDay()]} ,{" "}
                          {item.examDate
                            ? dayjs(item.examDate).format("DD/MM/YYYY")
                            : ""}
                        </td>
                        <td className="word-break">
                          {item.presentTime ? formatAMPM(item.presentTime) : ""}
                        </td>
                        <td className="word-break">
                          {item.getInTime ? formatAMPM(item.getInTime) : ""}
                        </td>
                        <td className="word-break">
                          {item.durationFrom ? formatAMPM(item.durationFrom) : ""}
                        </td>
                        <td className="word-break">
                          {item.durationTo ? formatAMPM(item.durationTo) : ""}
                        </td>
                        <td className="word-break">
                          {item.subjectName ? item.subjectName : ""}
                        </td>
                        <td className="word-break">
                          {item?.tableExamSubjectsDto
                            ? item?.tableExamSubjectsDto?.subjectName
                            : ""}
                        </td>
                        <td className="word-break">
                          {item.subjectCodes ? item.subjectCodes : ""}
                        </td>
                        <td className="word-break">
                          {item.examPatternName
                            ? item.examPatternName
                            : ""}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          }
        </div>
        <div
          className="side-box-one side-box"
          id="advertisement_fee_config_section"
        >
          <div className="card">
            <div className="card-header">
              {applicationStagesLabels.ADVERTISEMENT_FEES}
            </div>
            <div
              className="body ps-2 pe-2"
            >
              <div className="box-contents">
                <div className="row mt-2">
                  <div className="col-md-8">
                    <label>
                      <span>{applicationStagesLabels.OBJECTION_FEE}</span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control p-2"
                      type="text"
                      name="objection_fee"
                      maxLength="8"
                      placeholder="Enter numeric value"
                      onChange={(e) => {
                        setFieldValue("objection_fee", e);
                      }}
                      defaultValue={
                        advertisementDetails &&
                        advertisementDetails.advertisementConfig &&
                        advertisementDetails.advertisementConfig.objectionFee
                      }
                      ref={register({ maxLength: 8 })}
                    />
                    {_.get("objection_fee.type", errors) === "maxLength" && (
                      <p className="errorText float-start">
                        {commonLabels.MAX_CHAR_VALUE_8}
                      </p>
                    )}
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-8">
                    <label>
                      <span>{applicationStagesLabels.OBJECTION_SERVICE_CHARGES}</span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control p-2"
                      type="text"
                      maxLength="8"
                      name="objection_service_charges"
                      placeholder="Enter numeric value"
                      onChange={(e) => {
                        setFieldValue("objection_service_charges", e);
                      }}
                      defaultValue={
                        advertisementDetails &&
                        advertisementDetails.advertisementConfig &&
                        advertisementDetails.advertisementConfig
                          .objectionServiceCharges
                      }
                      ref={register({ maxLength: 8 })}
                    />
                    {_.get("objection_service_charges.type", errors) ===
                      "maxLength" && (
                        <p className="errorText float-start">
                          {commonLabels.MAX_CHAR_VALUE_8}
                        </p>
                      )}
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-8">
                    <label>
                      <span>{applicationStagesLabels.RETOTALING_FEE}</span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control p-2"
                      type="text"
                      maxLength="8"
                      name="retotaling_fee"
                      placeholder="Enter numeric value"
                      onChange={(e) => {
                        setFieldValue("retotaling_fee", e);
                      }}
                      defaultValue={
                        advertisementDetails &&
                        advertisementDetails.advertisementConfig &&
                        advertisementDetails.advertisementConfig.retotalingFee
                      }
                      ref={register({ maxLength: 8 })}
                    />
                    {_.get("retotaling_fee.type", errors) === "maxLength" && (
                      <p className="errorText float-start">
                        {commonLabels.MAX_CHAR_VALUE_8}
                      </p>
                    )}
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-8">
                    <label>
                      <span>{applicationStagesLabels.RETOTALING_SERVICE_CHARGES}</span>
                    </label>
                  </div>
                  <div className="col-md-4">
                    <input
                      className="form-control p-2"
                      type="text"
                      maxLength="8"
                      name="retotaling_service_charges"
                      placeholder="Enter numeric value"
                      onChange={(e) => {
                        setFieldValue("retotaling_service_charges", e);
                      }}
                      defaultValue={
                        advertisementDetails &&
                        advertisementDetails.advertisementConfig &&
                        advertisementDetails.advertisementConfig
                          .retotalingServiceCharges
                      }
                      ref={register({ maxLength: 8 })}
                    />
                    {_.get("retotaling_service_charges.type", errors) ===
                      "maxLength" && (
                        <p className="errorText float-start">
                          {commonLabels.MAX_CHAR_VALUE_8}
                        </p>
                      )}
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-8">
                    {" "}
                    <button
                      className=" btn btn-primary custom_button  btn-sm  "
                      onClick={() => {
                        updateAdvertimentFeeConfigData();
                      }}
                    >
                      {applicationStagesLabels.UPDATE}
                    </button>
                  </div>
                  <div className="col-md-4">&nbsp;</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="side-box-two side-box" id="hide_Block">
          <div className="card">
            <div className="card-header">{applicationStagesLabels.APPLICATION_STAGE}</div>
            <div
              className="body ps-2 pe-2"
            >
              <div className="box-contents">
                <ul className="notype">
                  {allStagesList &&
                    allStagesList.stageDtoList &&
                    allStagesList.stageDtoList.length > 0 &&
                    allStagesList.stageDtoList.map((elem, index) => (
                      <li key={index}>
                        <div className="row app_stage_sidebar_data">
                          <div className="col-9">
                            <span>{elem.name}</span>
                            <br />
                          </div>
                          <div className="col-3 text-right"></div>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showAddTimeTableState && (
        <AddTimeTable
          setShowAddTimeTableState={setShowAddTimeTableState}
          showAddTimeTableState={showAddTimeTableState}
        />
      )}
    </div>
  );
};

export default AdvertisementDetails;